import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ModalRef} from '@shared/components/modal/modal.ref';
import {Notification} from '@shared/components/notification/notification';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Notification],
  providers: [ModalRef],
  templateUrl: './app.html',
})
export class App {
}
